import { Box, Button, Typography } from '@material-ui/core';
import { ReactNode } from 'react';
import useStyles from './styles';

interface ICardProps {
  Icon?: ReactNode;
  icon?: string;
  title: string;
  text?: string;
  buttonText?: string;
  onButtonClick: () => void;
}
const Card = ({
  Icon,
  icon,
  title,
  text,
  onButtonClick,
  buttonText = 'Voltar para o Início',
}: ICardProps) => {
  const classes = useStyles();

  const handleClick = () => {
    onButtonClick();
  };

  return (
    <>
      {Icon && Icon}
      {icon && <img src={icon} alt="card-icon" />}
      <Box className={classes.container}>
        <Box className={classes.wrapperContent}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.contentText}>{text}</Typography>
        </Box>
        <Button className={classes.button} onClick={handleClick}>
          {buttonText}
        </Button>
      </Box>
    </>
  );
};
export default Card;
